import React, { useState } from "react"
import PropTypes from "prop-types"
import axios from '@utils/axios';

import TookanApiForm from '@presentational/shop/TookanApiForm';

const propTypes = {
  apiKey: PropTypes.string,
  submitURL: PropTypes.string.isRequired,
  // redirectURL: PropTypes.string,
}

const defaultProps = {
  apiKey: ""
}

const TookanApiFormContainer = (props) => {
  const [loading, setLoading] = useState(false);
  const [apiKey, setApiKey] = useState(props.apiKey)

  const submitForm = async () => {
    let { submitURL } = props;
    setLoading(true)

    try {
      let response = await axios.post(submitURL, {
        shop: {
          tookan_api_key: apiKey
        }
      });
      if(response.data.success){
        if (response.data.redirectURL){
          // redirect if required.
          window.location = response.data.redirectURL;
          return true
        } else {
          alert(response.data.message);
        }
        
      } // End success data
      else{
        alert(response.data.message);
      }
    } catch (error) {
      alert(error);
    } // END try/catch
    setLoading(false)

  }

  return(
    <TookanApiForm 
      handleApiKeyChange={ setApiKey }
      handleSubmit={ submitForm }
      apiKey={ apiKey }
      loading={ loading }
    />
  );
}

TookanApiFormContainer.propTypes = propTypes;
TookanApiFormContainer.defaultProps = defaultProps;

export default TookanApiFormContainer;
